import React, { useEffect, useRef } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { format } from "date-fns";
import "./PhoneInvoiceDetails.scss";
import QRCode from "react-qr-code";
import JsBarcode from "jsbarcode";

export default function PhoneInvoiceDetails({
  details,
  transactiondetails,
  invoiceTranslate,
  link,
  fiscalYear,
  actionType,
  invoiceNr
}) {
  const barcodeRef = useRef(null);
  const tableRef = useRef();

    const inv = "IND-" + fiscalYear + "-" + invoiceNr;


  const DetailRow = ({ label, value }) => (
    <Box className="detail-row">
      <Typography className="detail-row__label">{label}:</Typography>
      <Typography className="detail-row__value">{value}</Typography>
    </Box>
  );

  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, inv, {
        format: "CODE128",
        height: 30, // Lartësia në pikselë
        width: 1.5, // Gjerësia e shiritave
        text: actionType === "IND" ? inv : invoiceNr,
        fontSize: 12,
      });
    }
  }, [inv]);

  return (
    <Card className="details-section" elevation={1}>
      <CardContent className="details-section__content">
        <DetailRow
          label={invoiceTranslate.document}
          value={
            transactiondetails.length > 0
              ? transactiondetails[0].ActionType === "IND"
                ? "Faturë Shitje"
                : "Faturë Blerje"
              : ""
          }
        />

        <DetailRow
          label={invoiceTranslate.number}
          value={
            transactiondetails && transactiondetails.length > 0
              ? transactiondetails[0].ActionType
                ? `${transactiondetails[0].ActionType}-${transactiondetails[0].FiscalYear}-${transactiondetails[0].InvoiceNr}`
                : transactiondetails[0].InvoiceNr
              : ""
          }
        />

        <DetailRow
          label={invoiceTranslate.invDate}
          value={
            transactiondetails && transactiondetails.length > 0
              ? transactiondetails[0].Date
              : ""
          }
        />

        <DetailRow
          label={invoiceTranslate.payDate}
          value={
            transactiondetails && transactiondetails.length > 0
              ? transactiondetails[0].PayDate
              : ""
          }
        />

        <DetailRow
          label={invoiceTranslate.user}
          value={
            transactiondetails &&
            transactiondetails.length > 0 &&
            transactiondetails[0].CreatedByUser
              ? transactiondetails[0].CreatedByUser.split("@")[0]
              : ""
          }
        />

        <DetailRow
          label={invoiceTranslate.unit}
          value={
            transactiondetails && transactiondetails.length > 0
              ? transactiondetails[0].UnitName // nëse ke fushë për unit name
              : ""
          }
        />

        {/* <DetailRow label="Serial Number" value={details.serialNumber} />
        <DetailRow
          label="Invoice Date"
          value={format(new Date(details.invoiceDate), "dd/MM/yyyy")}
        />
        <DetailRow
          label="Payment Date"
          value={format(new Date(details.paymentDate), "dd/MM/yyyy")}
        />
        <DetailRow label="User" value={details.user} />
        <DetailRow label="Unit" value={details.unit} /> */}

        <Box className="details-section__codes">
          {/* QR code */}
          <div>
            {link && (
              <QRCode value={link} style={{ width: "50px", height: "50px" }} />
            )}
          </div>

          {/* Barcode */}
          <div>
            <svg ref={barcodeRef}></svg>
          </div>
          
        </Box>
      </CardContent>
    </Card>
  );
}
